import styles from '../../assets/styles/Login/Login.module.scss';
import LeftSide from '../pageComponents/LeftSide';
import LoginForm from './LoginForm';
import React from 'react';

function Login({
	switchToSignup,
	switchToForgotPassword,
	validationSchema,
	onSubmit,
	loading,
	owner,
	selectOwnerAccount,
}) {
	return (
		<div className={styles.container}>
			<LeftSide title="Welcome Back :)" />
			<div className={styles.rightside}>
				<div className={styles.logintext__center}>
					<h3 className={`${styles.logintext__title} ${styles.mb_30}`}>
						Log in
					</h3>

					<p className={styles.logintext__p}>
						Don’t have an account?{' '}
						<span className={styles.clickable} onClick={switchToSignup}>
							Sign up for free
						</span>
						<br /> it will take less than a minute
					</p>
				</div>
				<div className={styles.loginform}>
					<LoginForm
						validationSchema={validationSchema}
						onSubmit={onSubmit}
						loading={loading}
						owner={owner}
						selectOwnerAccount={selectOwnerAccount}
					/>
				</div>
				<div className={`${styles.logintext__p} ${styles.mt_40}`}>
					Forgot your password?
					<span className={styles.clickable} onClick={switchToForgotPassword}>
						{' '}
						Click Here
					</span>
				</div>
			</div>
		</div>
	);
}

export default Login;
